import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  Filter,
  Show,
  SimpleShowLayout,
  ReferenceInput,
  DateField,
  ReferenceField,
  AutocompleteInput
} from 'react-admin'

export const SessionFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput
      source='userId'
      reference='user'
      allowEmpty
      alwaysOn
      filterToQuery={searchText => ({ username: {$regex: searchText, $options: 'i'} })}
    >
      <AutocompleteInput optionText='username' translateChoice={false} />
    </ReferenceInput>
  </Filter>
)

export const SessionShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source='id' />
      <ReferenceField source='userId' reference='user'>
        <TextField source='username' allowEmpty />
      </ReferenceField>
      <DateField source='createdAt' showTime />
      <DateField source='updatedAt' showTime />
    </SimpleShowLayout>
  </Show>
)

export const SessionList = (props) => (
  <List {...props} filters={<SessionFilter />}>
    <Datagrid
      rowClick='show'
    >
      <ReferenceField source='userId' reference='user'>
        <TextField source='username' allowEmpty />
      </ReferenceField>
      <DateField source='createdAt' />
      <DateField source='updatedAt' />
    </Datagrid>
  </List>
)
